import { useAppSelector } from "store/hooks";
import {
  selectAllSearchParams,
  selectFParam,
  selectTParam,
} from "store/selectors/inboxSelectors";
import useSelectedPageSearchParams from "./useSelectedPageSearchParams";
import useInbox from "hooks/useInbox";
import { type RootState } from "store/store";
import { url } from "inspector";

const FIRST_PAGE_NUM = 1;
const DEFAULT_ITEMS_PER_PAGE = 10;

const useUrlLink = () => {
  const pageType = useAppSelector(selectTParam);
  const pageCategory = useAppSelector(selectFParam);
  const allSearchParams = useAppSelector(selectAllSearchParams);
  const { getSelectedPageSearchParams } = useSelectedPageSearchParams();

  const {
    setPageType,
    setPageCategory,
    setSorting,
    setPageNumber,
    setItemsPerPage,
    setSearchParams,
  } = useInbox();

  const getNewPageTypeUrl = (
    newPageType: RootState["inbox"]["searchParams"]["t"]
  ) => {
    const url =
      window.location.origin +
      window.location.pathname +
      `?t=${newPageType}f=${pageCategory}pn=1&items=10&sortBy=date&asc=true&${getSelectedPageSearchParams(
        newPageType
      )}`;

    return url;
  };

  const getCategoryFilterUrl = (
    selectedPageCategory: keyof typeof allSearchParams
  ) => {
    const selectedPageSearchParams = getSelectedPageSearchParams(
      selectedPageCategory === "picker" ? "picker" : pageType
    );

    const pickerUrl =
      window.location.origin +
      window.location.pathname +
      `?t=picker&pn=1&sortBy=date&asc=true&${selectedPageSearchParams}`;

    const url =
      window.location.origin +
      window.location.pathname +
      `?t=${pageType}f=${selectedPageCategory}pn=1&items=10&sortBy=date&asc=true&${selectedPageSearchParams}`;

    return selectedPageCategory === "picker" ? pickerUrl : url;
  };

  const navigateToNewPageType = (
    newPageType: RootState["inbox"]["searchParams"]["t"]
  ) => {
    if (window.location.pathname.includes("/manageStorage")) {
      setSearchParams({
        sm: [],
      });
    }

    setPageType(newPageType);

    // Don't allow to switch to sent jumbo forms page;
    // remove category instead.
    if (pageCategory === "jform" && newPageType === "sent") {
      setPageCategory("");
    }

    // Reset sorting and pagination when switching between pages
    setSorting({ by: "date", asc: true });
    setPageNumber(FIRST_PAGE_NUM);
    setItemsPerPage(DEFAULT_ITEMS_PER_PAGE);

    const urlSearchParams = new URLSearchParams(window.location.search);

    if (newPageType === "picker") {
      urlSearchParams.delete("sm");
      urlSearchParams.delete("sa");
      urlSearchParams.delete("l");
      urlSearchParams.delete("sf");
      urlSearchParams.delete("su");
      if (allSearchParams?.picker?.ps.length) {
        urlSearchParams.set("ps", allSearchParams?.picker.ps?.join(",") || "");
      }
      if (allSearchParams?.picker?.p) {
        urlSearchParams.set("p", allSearchParams?.picker.p || "");
      }
    } else {
      urlSearchParams.delete("ps");
      const params = ["sm", "sa", "l", "sf", "su"];
      for (const param of params) {
        //@ts-ignore
        if (allSearchParams?.[newPageType]?.[param]?.length) {
          urlSearchParams.set(
            param,
            //@ts-ignore
            allSearchParams?.[newPageType]?.[param]?.join(",") || ""
          );
        } else {
          urlSearchParams.delete(param);
        }
      }

      if (window.location.pathname.includes("/manageStorage")) {
        urlSearchParams.delete("sm");
      }
    }

    const pathnameWithoutManageStorage = window.location.pathname.replace(
      "/manageStorage",
      ""
    );

    window.history.pushState(
      {},
      "",
      window.location.origin +
        pathnameWithoutManageStorage +
        "?" +
        urlSearchParams
    );
  };

  const navigateToNewCategoryType = (
    newCategoryType: RootState["inbox"]["searchParams"]["f"]
  ) => {
    if (newCategoryType === "picker") {
      navigateToNewPageType("picker");
      setPageCategory("");
    } else {
      if (pageCategory === newCategoryType) {
        setPageCategory("");
      } else {
        setPageCategory(newCategoryType);
      }
      setPageType(
        newCategoryType === "jform" &&
          (pageType === "sent" || pageType === "picker")
          ? "received"
          : pageType === "picker"
          ? "sent"
          : pageType
      );
    }
    // if (window.location.pathname.includes("/manageStorage")) {
    //   window.location.pathname = window.location.pathname.replace(
    //     "/manageStorage",
    //     ""
    //   );
    // }
  };

  return {
    getNewPageTypeUrl,
    getCategoryFilterUrl,
    navigateToNewPageType,
    navigateToNewCategoryType,
  };
};

export default useUrlLink;
